import Keycloak, { KeycloakConfig, KeycloakInstance } from 'keycloak-js'

import logger from 'utils/logger'

// @ts-expect-error ts(7015)
const primaEnv = window['_env_']
const keycloakUrl = primaEnv?.REACT_APP_KEYCLOAK_URL ?? process.env.REACT_APP_KEYCLOAK_URL
const keycloakRealm = primaEnv?.REACT_APP_KEYCLOAK_REALM ?? process.env.REACT_APP_KEYCLOAK_REALM

// @ts-expect-error:  ts(7009)
const keycloakClient: KeycloakInstance = new Keycloak({
  realm: keycloakRealm,
  url: keycloakUrl,
  clientId: 'prima-login',
} as KeycloakConfig)

// Keycloak >= 26 rejects keycloak-js 11's logout `redirect_uri`; send the OIDC RP-initiated logout params instead
const createLegacyLogoutUrl = keycloakClient.createLogoutUrl
keycloakClient.createLogoutUrl = (options) => {
  const url = new URL(createLegacyLogoutUrl(options))
  url.searchParams.set(
    'post_logout_redirect_uri',
    url.searchParams.get('redirect_uri') ?? window.location.href
  )
  url.searchParams.delete('redirect_uri')
  url.searchParams.set('client_id', 'prima-login')
  if (keycloakClient.idToken) {
    url.searchParams.set('id_token_hint', keycloakClient.idToken)
  }
  return url.toString()
}

export let initialized = false

function initKeycloakClient() {
  initialized = false
  keycloakClient
    .init({
      onLoad: 'login-required',
      enableLogging: true,
      checkLoginIframe: true,
      // Keycloak >= 26 rejects redirect_uri with a fragment (href still holds the #state/code callback here)
      redirectUri: window.location.origin + window.location.pathname + window.location.search,
    })
    .then((authenticated) => {
      initialized = true
    })
    .catch((error) => {
      initialized = false
      logger.error(`keycloak native promise - error: ${error}`)
    })
}

keycloakClient.onTokenExpired = () => {
  logger.warn('token expired at', new Date())

  keycloakClient
    .updateToken(5)
    .then((refreshed) => {
      if (refreshed) {
        initialized = true
      }
    })
    .catch(() => {
      logger.error('Failed to refresh the token, or the session has expired')
      keycloakClient.logout()
      initKeycloakClient()
    })
}

initKeycloakClient()

export default keycloakClient
